import { render, staticRenderFns } from "./accept.vue?vue&type=template&id=6770c9ea&scoped=true&"
import script from "./accept.vue?vue&type=script&lang=js&"
export * from "./accept.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6770c9ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6770c9ea')) {
      api.createRecord('6770c9ea', component.options)
    } else {
      api.reload('6770c9ea', component.options)
    }
    module.hot.accept("./accept.vue?vue&type=template&id=6770c9ea&scoped=true&", function () {
      api.rerender('6770c9ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/withdraw_requests/actions/accept.vue"
export default component.exports